import { Route } from '@angular/router';

/** Utilities, search, forecast, print/template hub, sync tools. */
export const utilitiesChildren: Route[] = [
  {
    path: 'utilities',
    loadChildren: () =>
      import('app/modules/utilities/utilities.module').then((m) => m.UtilitiesModule),
  },
  {
    path: 'search',
    loadChildren: () => import('app/modules/platform/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'global-search',
    loadComponent: () =>
      import('app/modules/platform/global-search/global-search.component').then(
        (m) => m.GlobalSearchComponent,
      ),
    data: { permission: 'other.tools.globalSearch' },
  },
  {
    path: 'forecast',
    loadComponent: () =>
      import('app/modules/platform/forecast/forecast.component').then((m) => m.ForecastComponent),
  },
];
